<ion-header>
  <ion-toolbar mode="ios">
    <ion-title>{{'ABOUT_US'| translate }}</ion-title>
    
    <ion-buttons slot="end">
      <ion-button (click)="back()" slot="end">
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>
<ion-content *ngIf="context">
  <div [innerHTML]="context"></div>
</ion-content>
